
import { types, actions } from './requests'
export const DELETEFAMILY_TYPES = {
    ...types('DELETEFAMILY'),
}
export const DELETEFAMILY_ACTIONS = {
    ...actions('DELETEFAMILY'),
}